export type VideoScoreBand = "Very weak" | "Weak" | "Medium" | "Strong" | "Very strong";

/**
 * getVideoScoreBand function
 * Maps a 1–5 video sub-metric score (Hook / Visual ease / Hold) to a qualitative band,
 * mirroring the 1–5 MemoryScore convention used elsewhere in reports.
 *
 * @param score - The sub-metric score on a 1–5 scale
 * @returns The qualitative band label for the score
 */
export const getVideoScoreBand = (score: number): VideoScoreBand => {
  if (score <= 1) return "Very weak";
  if (score <= 2) return "Weak";
  if (score <= 3) return "Medium";
  if (score <= 4) return "Strong";
  return "Very strong";
};

/**
 * getVideoScoreBandColor function
 * Returns the indicator colour for a 1–5 video sub-metric score, reusing the memory-indicator palette.
 *
 * @param score - The sub-metric score on a 1–5 scale
 * @returns A hex colour string for the score's band
 */
export const getVideoScoreBandColor = (score: number): string => {
  if (score <= 1) return "#DC3545"; // Very weak (red)
  if (score <= 2) return "#DC7135"; // Weak (orange)
  if (score <= 3) return "#C8C000"; // Medium (yellow)
  if (score <= 4) return "#80B918"; // Strong (light green)
  return "#198754"; // Very strong (green)
};
